import { ContentObjectWatcher } from '@mbrtargeting/metatag-shared-modules';
import { SystemEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';
import { selectFeatureSettings } from '../../../loader/essentials/config-selector.js';
import { triggerEvent } from '../../../loader/essentials/events.js';
import { logger } from '../../../loader/essentials/logger.js';
import { CONFIG_RESOLVER } from '../../../loader/token.js';

const log = logger.logGroup({ prefix: 'ContentObjectWatcher' });

@injectionTarget()
export class MetaTagContentObjectWatcher extends ContentObjectWatcher {

    @inject(CONFIG_RESOLVER) configResolver!: ConfigResolver;

    constructor() {
        super();
        const { contentWidthModifier = '0', contentTopModifier = '0', contentLeftModifier = '0', contentContainerQuery = '' } = this.configResolver.get(selectFeatureSettings());

        this.configure({
            contentWidthModifier: parseInt(contentWidthModifier),
            contentTopModifier: parseInt(contentTopModifier),
            contentLeftModifier: parseInt(contentLeftModifier),
            contentContainerQuery
        });

        //as soon as element is found, let connected modules know
        this.contentObjectPromise.then(contentObject => {
            triggerEvent(SystemEvent.SDG_CONTENT_ELEMENT_LOADED, {
                passedObject: contentObject.element
            });
        });

        this.contentObject$.subscribe(contentObject => {
            log.debug('contentObject=%o', [contentObject]);
        });
    }
}
